import React from 'react';

import { FlexRow } from 'ui-components/components/flex';

import LabeledField from '../labeled-field';
import RateBrowserButton from '../../../../../fulfillment-planner/rate-browser-button';
import RequestedShippingService from '../../../../../fulfillment-planner/requested-shipping-service';
import { RequestedShippingServiceLabel } from '../../../shared-field-labels/shared-field-labels';
import { useEnableMultiPackageShipmentsOrderDetails } from '../../../../../feature-flags/hooks/use-multi-package-shipping-order-details';
import sharedFieldStyle from '../../../shared-field-labels/form-fields.module.less';
import style from './requested-service.module.less';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @returns {JSX.Element}
 */
const RequestedService = ({ fulfillmentPlanId }) => {
  const enableMultiPackageShipmentsOrderDetails = useEnableMultiPackageShipmentsOrderDetails();

  // TODO: use this version when the feature flag is removed
  if (enableMultiPackageShipmentsOrderDetails) {
    return (
      <LabeledField label={RequestedShippingServiceLabel}>
        <FlexRow className={style['requested-service-container']}>
          <div className={style['shipping-service-wrapper']}>
            <RequestedShippingService className={sharedFieldStyle['readonly-value']} fulfillmentPlanId={fulfillmentPlanId} />
          </div>
          <div className={style['rate-browser-button-wrapper']}>
            <RateBrowserButton />
          </div>
        </FlexRow>
      </LabeledField>
    );
  }

  return (
    <LabeledField label={RequestedShippingServiceLabel}>
      <RequestedShippingService className={sharedFieldStyle['readonly-value']} fulfillmentPlanId={fulfillmentPlanId} />
    </LabeledField>
  );
};

export default RequestedService;
